import { render } from "./UsefulTips.vue?vue&type=template&id=795c84dc"
import script from "./UsefulTips.vue?vue&type=script&lang=js"
export * from "./UsefulTips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__